import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { environment } from '../../environments/environment';
import { NGXLogger } from 'ngx-logger';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  constructor(
    private logger: NGXLogger,
    private messageService: MessageService,
    private translate: TranslateService,
  ) {}

  public debug(origin: string, msg: any): void {
    if(environment.log.debug) {
      this.logger.debug(`${origin}`, msg);
    }
  }

  public error(origin: string, msg: any, toastMsg?: string): void {
    if(environment.log.error) {
      this.logger.error(`${origin}`, msg);
    }

    if(!toastMsg) return;

    const message = msg.message?.key && msg.message?.key !== 'ERROR_DEFAULT' ? 
      this.translate.instant('api_error.' + msg.message.key) : toastMsg;
    this.messageService.add({
      severity: 'error',
      summary: message,
    });
  }

  public info(origin: string, msg: any, toastMsg?: string): void {
    if(environment.log.info) {
      this.logger.info(`${origin}`, msg);
    }
    if (toastMsg) {
      this.messageService.add({
        severity: 'info',
        summary: toastMsg,
        detail: '',
      });
    }
  }

  public warn(origin: string, msg: any, toastMsg?: string, toastTitle?: string): void {
    if(environment.log.warn) {
      this.logger.warn(`${origin}`, msg);
    }
    if (toastMsg && toastTitle) {
      this.messageService.add({
        severity: 'warn',
        summary: toastTitle,
        detail: toastMsg,
      });
    } else if(toastMsg) {
      this.messageService.add({
        severity: 'warn',
        summary: toastMsg
      });
    }
  }
}
